import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import GroupSection from "./GroupSection";
import { formatDateOnly } from "../../utils/DateTimeUtil";

function OrganizationSection({
  organization,
  isExpanded,
  onToggle,
  expandedGroups,
  onGroupToggle,
  onUserAssignmentClick,
}) {
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return formatDateOnly(dateString, "short");
  };

  return (
    <div className="common-section organization-section">
      <div
        className="common-section-header organization-header"
        onClick={() => onToggle(organization.orgId)}
      >
        <div className="header-content">
          <FontAwesomeIcon
            icon={isExpanded ? faChevronDown : faChevronRight}
            className="expand-icon"
          />
          <FontAwesomeIcon icon={faBuilding} className="section-icon" />
          <div className="header-text">
            <h3>{organization.name}</h3>
            <span className="group-count">
              {organization.groups.length} group
              {organization.groups.length !== 1 ? "s" : ""}
            </span>
          </div>
        </div>
      </div>

      {isExpanded && (
        <div className="common-section-content">
          <div className="common-form-group">
            <h4>Organization Information</h4>
            <div className="account-info-grid">
              <div className="info-item">
                <label>Organization ID:</label>
                <span>{organization.orgId}</span>
              </div>
              <div className="info-item">
                <label>Created:</label>
                <span>{formatDate(organization.createdAt)}</span>
              </div>
              <div className="info-item">
                <label>Groups:</label>
                <span>
                  {organization.groups.length} group
                  {organization.groups.length !== 1 ? "s" : ""}
                </span>
              </div>
            </div>
          </div>

          <div className="common-form-group">
            <h4>Groups in this Organization</h4>
            <div className="groups-container">
              {organization.groups.map((group) => (
                <GroupSection
                  key={group.groupName || group.name}
                  group={group}
                  isExpanded={expandedGroups.has(group.groupName || group.name)}
                  onToggle={onGroupToggle}
                  onUserAssignmentClick={onUserAssignmentClick}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default OrganizationSection;
